import { Map } from "immutable";

const initialState = Map({
	rolesMap: Map(),
});

export default function roles(state = initialState, action) {
	/*
        rolesMap: {
            roleID : { _id, name }
        }
    */

	switch (action.type) {
		case "ROLES:SET": {
			return state.setIn(["rolesMap"], action.rolesMap);
		}

		default: {
			return state;
		}
	}
}
